import React, { useEffect, useState, useRef } from 'react';
import { RefreshCw } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Bannière « nouvelle version » : les onglets/PWA déjà ouverts détectent un
// nouveau déploiement et proposent d'actualiser (sinon ils gardent l'ancien bundle).
export const UpdateBanner = () => {
  const [updateReady, setUpdateReady] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const initialBuild = useRef(null);

  // Demande au Service Worker de télécharger la nouvelle version AVANT de recharger,
  // sinon le cache servirait encore l'ancien index.html.
  const applyUpdate = () => {
    setRefreshing(true);
    const sw = navigator.serviceWorker?.controller;
    if (!sw) { window.location.reload(); return; }
    const requestId = `shell-${Date.now()}`;
    const done = (e) => {
      if (e.data?.type === 'SHELL_REFRESH_DONE' && e.data.requestId === requestId) {
        navigator.serviceWorker.removeEventListener('message', done);
        window.location.reload();
      }
    };
    navigator.serviceWorker.addEventListener('message', done);
    sw.postMessage({ type: 'SHELL_REFRESH', requestId });
    setTimeout(() => window.location.reload(), 20000);
  };

  useEffect(() => {
    let stopped = false;
    const check = async () => {
      try {
        const r = await fetch(`${API_URL}/api/version`, { cache: 'no-store' });
        if (!r.ok) return;
        const { build } = await r.json();
        if (!build || build === 'dev' || build === 'unknown') return;
        if (initialBuild.current === null) {
          initialBuild.current = build;
        } else if (build !== initialBuild.current && !stopped) {
          setUpdateReady(true);
        }
      } catch { /* hors-ligne — on réessaiera */ }
    };
    check();
    const interval = setInterval(check, 5 * 60 * 1000);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { stopped = true; clearInterval(interval); document.removeEventListener('visibilitychange', onVisible); };
  }, []);

  if (!updateReady) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-3 px-4 py-2.5 bg-obgh-orange text-black shadow-lg" data-testid="update-banner">
      <span className="text-xs font-black uppercase tracking-wider">Nouvelle version disponible</span>
      <button
        onClick={applyUpdate}
        disabled={refreshing}
        data-testid="update-reload-btn"
        className="flex items-center gap-1.5 px-3 py-1 bg-black text-obgh-orange rounded-sm text-[11px] font-black uppercase tracking-wider hover:bg-zinc-900 disabled:opacity-70"
      >
        <RefreshCw size={12} className={refreshing ? 'animate-spin' : ''} /> {refreshing ? 'Téléchargement…' : 'Actualiser'}
      </button>
    </div>
  );
};
